import { render, staticRenderFns } from "./contact-modal.vue?vue&type=template&id=72377f1d&scoped=true"
import script from "./contact-modal.vue?vue&type=script&lang=ts"
export * from "./contact-modal.vue?vue&type=script&lang=ts"
import style0 from "./contact-modal.vue?vue&type=style&index=0&id=72377f1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72377f1d",
  null
  
)

export default component.exports